// Primary is by flag only. Status does not matter (inactive primary still
// shows). Additional boats are filtered to Active elsewhere.
function findPrimaryBoat(boats) {
	if (!boats) return

	return boats.find(({ primary_boat__c }) => primary_boat__c === true)
}

export default findPrimaryBoat
